import React, { FC } from 'react';
import ModalDialog from '../components/modal/ModalDialog';
import './CheckBeforeAddingModal.scss';
import { Button, ButtonSize } from './Button';
import { Trans, useTranslation } from 'react-i18next';
import HorizontalRuler from './HorizontalRuler';
import { ProductOut } from '../../store/api';
import { ExpandableTable } from './TableRow';

export type UnavailableProductsModalProps = {
    readonly unavailableProducts: ProductOut[];
    readonly onDismiss: () => void;
};

export const UnavailableProductsModal: FC<UnavailableProductsModalProps> = ({ unavailableProducts, onDismiss }) => {
    const HEIGHT_SPACER = 5;
    const { t } = useTranslation();

    if (unavailableProducts.length < 1) {
        return null;
    }

    return (
        <ModalDialog
            show={true}
            title={t('notifications.unavailableProductsModal.notAdded.title')}
            titleClassName="title"
            wrapClassName="check-before-adding-modal"
            boldHeader={false}
        >
            <HorizontalRuler heightSpacer={HEIGHT_SPACER} />
            <div className="description">
                <Trans
                    i18nKey="notifications.unavailableProductsModal.notAdded.message"
                    components={{
                        br: <br />
                    }}
                />
            </div>
            <ExpandableTable products={unavailableProducts} />
            <br />
            <div className="actions">
                <Button onClick={onDismiss} text={t('ok')} className="proceed-button" size={ButtonSize.LARGE} />
            </div>
        </ModalDialog>
    );
};
